import { Link } from "react-router";
import { useTrads } from "../contexts/trads/useTrads";
function NoMatch() {
  const {translate}=useTrads();
  return (
    <div>
      <h2>{translate('404_titre')}</h2>
      <p>
          <Link to="/">{translate('404_texte')}</Link>
      </p>
    </div>
  );
}
export default NoMatch;